import type { ReactNode } from 'react';
import { AgenthubInterruptContext, type AgenthubInterruptContextValue } from './agenthubInterrupts';

export function AgenthubInterruptProvider({
  value,
  children,
}: {
  value: AgenthubInterruptContextValue;
  children: ReactNode;
}) {
  return <AgenthubInterruptContext.Provider value={value}>{children}</AgenthubInterruptContext.Provider>;
}
